/**
 * LocalStorage middleware script file
 *
 * @package    Middleware
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import {
    SET_LOCALE,
} from 'Actions/general';

export default () => () => (next) => (action) => {
    if (action.type) {
        switch (action.type) {
            case SET_LOCALE:
                localStorage.setItem('locale', action.locale);
                break;
        }
    }

    return next(action);
};
